import { Typography, Modal, Button, Spinner } from '@ag1/ui';
import { routes } from '@portal/constants/routes';
import { VenmoPage } from '@portal/schema/studio/commonContentSchema';

import styles from './CancelVenmoModal.module.scss';

interface CancelVenmoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (resubscribe: boolean) => void;
  isCancelLoading: boolean;
  modalData: VenmoPage['venmoCancellationModal'];
}

export const CancelVenmoModal = ({
  isOpen,
  onClose,
  onSubmit,
  isCancelLoading,
  modalData
}: CancelVenmoModalProps) => {
  const {
    modalHeader,
    cancellationText,
    contactSupportText,
    contactSupportHref,
    resubscribeButton,
    cancelButton
  } = modalData;

  return (
    <Modal
      className={styles.modal}
      isOpen={isOpen}
      onClose={onClose}
      mode="center"
      overlayClassName={styles.modalOverlay}
      shouldCloseOnEsc>
      <Modal.Header className={styles.modalHeader}>
        <Typography variant="portalSubtitleBold" size="1" noPadding>
          {modalHeader}
        </Typography>
      </Modal.Header>
      <Modal.Content className={styles.modalContent}>
        <Typography variant="portalText" size="1" noPadding>
          {cancellationText}
        </Typography>
        <br />
        <Typography variant="portalText" size="1" noPadding color="brand-green-new">
          {contactSupportText}{' '}
          <Button
            href={routes.customerService}
            theme="new"
            variant="link"
            size="small"
            noPadding
            className={styles.contactButton}>
            {contactSupportHref}
          </Button>
        </Typography>
      </Modal.Content>
      <Modal.Footer className={styles.modalFooter}>
        <Button
          variant="primary"
          size="small"
          onClick={() => onSubmit(true)}
          disabled={isCancelLoading}>
          {isCancelLoading ? (
            <Spinner color="brand-white" size={24} withOverlay={false} />
          ) : (
            resubscribeButton
          )}
        </Button>
        <Button
          variant="outlineGray"
          size="small"
          onClick={() => onSubmit(false)}
          disabled={isCancelLoading}>
          {isCancelLoading ? (
            <Spinner color="brand-white" size={24} withOverlay={false} />
          ) : (
            cancelButton
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
